import { z } from 'zod';

export const McpTesterFormSchema = z.object({
  address: z.string().trim().min(1, 'Enter an MCP server address'),
});

export type McpTesterFormModel = z.infer<typeof McpTesterFormSchema>;

export const MCP_TESTER_FORM_DEFAULTS: McpTesterFormModel = { address: '' };
